import { render, staticRenderFns } from "./DevicesPage.html?vue&type=template&id=2a5a79b9&scoped=true&"
import script from "./DevicesPage.ts?vue&type=script&lang=ts&"
export * from "./DevicesPage.ts?vue&type=script&lang=ts&"
import style0 from "./DevicesPage.scss?vue&type=style&index=0&id=2a5a79b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5a79b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VIcon,VSwitch})
